import requestService from "../requestService"

export default {
	async login(form) {
		const response = await requestService.post(`/login`, form)
		return response?.data
	},
	// async resetPassword(form) {
	// 	const response = await requestService.post(`/v1/password/email`, form)
	// 	return response?.data
	// },
	// async changePassword(form) {
	// 	const response = await requestService.post(`/v1/password/reset`, form)
	// 	return response?.data
	// }
}